import { $, $$ } from './dom';

const SimpleLightbox = require('simple-lightbox');
const { tns } = require('../../../node_modules/tiny-slider/src/tiny-slider');

const sliderHook = document.querySelector('.js-product-thumbs');

if (sliderHook) {
    tns({
        container: '.js-product-thumbs',
        slideBy: 1,
        speed: 500,
        autoplay: false,
        center: false,
        mouseDrag: true,
        nav: false,
        autoplayButtonOutput: false,
        loop: true,
        items: 2,
        edgePadding: 50,
        controlsText: ['\uf053', '\uf054'],
        arrowKeys: false,

        responsive: {
            [window.cssBreakpoints.desk]: {
                items: 2,
                edgePadding: 50,
            },
        },
    });

    const currentImgContainer = document.getElementById('js-product-slider-current-container');
    const currentImg = currentImgContainer.querySelector('img');

    const selectThumbHandler = function selectThumbHandler(e) {
        e.stopPropagation();
        document.activeElement.blur(); // remove focus on tns buttons
        const activeSlides = (sliderHook.querySelectorAll('.tns-slide-active'));
        if (e.currentTarget !== activeSlides[0] && e.currentTarget !== activeSlides[3]) {
            const thumbImg = e.currentTarget.querySelector('img');
            currentImg.src = thumbImg.dataset.fullSrc;
            currentImg.targetLightboxHook = thumbImg.parentElement.parentElement;
        }
    };

    const selectCurrentHandler = function selectCurrentHandler() {
        document.activeElement.blur(); // remove focus on tns buttons
        currentImg.targetLightboxHook.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: false,
            cancelable: true,
        }));
    };

    currentImg.addEventListener('click', selectCurrentHandler);
    currentImg.addEventListener('tap', selectCurrentHandler);
    currentImg.targetLightboxHook = null;

    document.querySelectorAll('.js-product-slider-thumb').forEach((thumb) => {
        thumb.addEventListener('mouseover', selectThumbHandler);
        thumb.addEventListener('click', selectThumbHandler);
        thumb.addEventListener('tap', selectThumbHandler);

        const thumbImg = thumb.querySelector('img');
        // featured image detected! wire it up early
        // tns toys with the natural DOM order so we use a data-attr instead
        if (thumbImg.dataset.featured === 'true') {
            currentImg.src = thumbImg.dataset.fullSrc;
            currentImg.targetLightboxHook = thumb;
        }
        // video detected, shim the href to point at an embed, always.
        if (thumbImg.dataset.type === 'video') thumb.setAttribute('data-href', global.quietmark.video.makeEmbedUrl(thumbImg.dataset.videoSrc));
    });

    // eslint-disable-next-line no-new
    new SimpleLightbox({ elements: '.js-product-thumbs a', urlAttribute: 'data-href' });
}

if ($('.js-product-similars')) {
    $$('.js-product-similars').forEach((slider) => tns({
        container: slider,
        slideBy: 1,
        speed: 500,
        autoplay: false,
        center: false,
        mouseDrag: true,
        nav: false,
        autoplayButtonOutput: false,
        loop: false,
        items: 2,
        controlsText: ['‹', '›'],
        gutter: 20,

        responsive: {
            [window.cssBreakpoints.tab]: {
                items: 3,
            },
            [window.cssBreakpoints.desk]: {
                items: 5,
            },
        },
    }));
}
